/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropsdescription1Inputs */

const en_dropsdescription1 = /** @type {(inputs: Dropsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-app giveaways: create, publish, draw, and contact winners`)
};

const de_dropsdescription1 = /** @type {(inputs: Dropsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinnspiele in der App: erstellen, veröffentlichen, ziehen und Gewinner kontaktieren`)
};

/**
* | output |
* | --- |
* | "In-app giveaways: create, publish, draw, and contact winners" |
*
* @param {Dropsdescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropsdescription1 = /** @type {((inputs?: Dropsdescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropsdescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropsdescription1(inputs)
	return de_dropsdescription1(inputs)
});
export { dropsdescription1 as "dropsDescription" }